import { createApp } from "vue";
import "element-plus/dist/index.css";
import "@/styles/less/index.less";
import "@/styles/css/index.css";

import ElementPlus from "element-plus";

import router from "@/router/index";
import store from "@/store/index";

import App from "./App.vue";
var app = createApp(App);
// import VueCropper from "vue-cropper";

//全局方法
import filters from "@/utils/helpers/filters";
import timer from "@/utils/helpers/timer";
Object.getOwnPropertyNames(filters).forEach(function (key) {
  app.config.globalProperties[key] = filters[key];
});
Object.getOwnPropertyNames(timer).forEach(function (key) {
  app.config.globalProperties[key] = timer[key];
});

import { hasPermission, checkPermission } from '@/utils/helpers/auth.js'
import { openRef } from "@/utils/tool.js";
import apis from "@/apis/index.js";
import msg from "@/utils/msg.js";
import common from "@/utils/common.js";

app.config.globalProperties.$checkPermission = checkPermission
app.config.globalProperties.$openRef = openRef;
app.config.globalProperties.$apis = apis;
app.config.globalProperties.$msg = msg;
app.config.globalProperties.$common = common;

//全局组件-面包屑
import BreadCrumb from "@/components/layout/breadCrumb.vue";
app.component("BreadCrumb", BreadCrumb);
//全局组件-展示用户信息公用组件
import UserInfo from "./components/common/userInfo.vue"
app.component("UserInfo", UserInfo);

//表格组件
import SearchTable from "@/components/xituan/table/searchTable.vue"
app.component("SearchTable", SearchTable);
//表单组件-仅显示
import showForm from '@/components/xituan/form/showForm.vue'
app.component('ShowForm', showForm)
//选择优惠券组件
import couponSelectForm from '@/components/xituan/form/couponSelectForm.vue'
app.component('CouponSelectForm', couponSelectForm)
//权限按钮组件
import permissionButton from '@/components/permission/button.vue'
app.component('permissionButton', permissionButton)
//图片展示组件
import imageFrame from '@/components/imageFrame/index.vue'
app.component('ImageFrame', imageFrame)
// 订单号跳转组件
import orderNoLink from '@/components/common/orderNoLink.vue'
app.component('OrderNoLink', orderNoLink)

app.use(ElementPlus, { size: "default", zIndex: 3000 });
app.use(router).use(store).use(hasPermission).mount('#app')
